module.exports = __webpack_public_path__ + "img/disease.6214e551.svg";